module.exports = __webpack_public_path__ + "img/ic_service_item_img3.84eb56fe.png";